import { TransactionCardSpend, TransactionStatus } from '@/features/Transactions/transactions.types'
import React from 'react'
import styles from '@/features/Transactions/ui/MobileTxRow/MobileTxRow.module.scss'
import { TransactionDetails } from '@/features/Transactions/ui/MobileTxRow/Common/TransactionDetails'
import { formatSimpleToken, formatTokenAmount, getSign } from '@/shared/helpers/crypto'
import classnames from 'classnames'
import { Flex } from 'antd'
import { mints } from '@/shared/constants/mints'
import { Icon } from '@/features/Transactions/ui/MobileTransactionDetails/Icon/Icon'

export function CardReverse({ transaction, onClick, withoutDate }: {
  onClick: () => void;
  transaction: TransactionCardSpend;
  withoutDate: boolean;
}) {
  const { merchantName, amount, originalAmount, cardTransactionType } = transaction.data
  const { createdAt, status } = transaction

  const sign = getSign(transaction.data.amount) === '+' ? 'CHANGE_BALANCE_UP' : 'CHANGE_BALANCE_DOWN'

  const isError = status === TransactionStatus.ERROR_SEND || status === TransactionStatus.FAILED
  const hasOriginalAmount = typeof amount !== 'string' && Number(originalAmount.amount) > 0

  return (
    <div className={classnames(styles.txRow)}>
      <Flex onClick={onClick} gap={12} align="center">
        <div
          className={classnames(
            styles.txIcon,
            status === 'IN_PROGRESS' && styles.txIconLoading,
            isError && styles.txIconError,
          )}
        >
          <Icon type={sign} />
        </div>
        <TransactionDetails
          title={merchantName}
          createdAt={createdAt}
          status={status}
          withoutDate={withoutDate}
          isError={isError}
          txType={cardTransactionType}
        />
        <div className={styles.txAmount}>
          <p className={classnames(
            styles.txTokenAmount,
            sign && sign === 'CHANGE_BALANCE_UP' && styles.txGreen,
            sign && sign === 'CHANGE_BALANCE_DOWN' && styles.txRed,
            isError && styles.errorTxGrey,
          )}
          >
            {sign === 'CHANGE_BALANCE_UP' && '+'}
            {typeof amount === 'string'
              ? `0 ${mints[transaction.data.amount.mint]}`
              : hasOriginalAmount
                ? `${formatSimpleToken(originalAmount.amount, 4)} ${originalAmount.currency}`
                : formatTokenAmount(transaction.data.amount, true)}
          </p>
          <p className={classnames(styles.txUsdAmount, isError && styles.errorTxGrey)}>
            {typeof amount === 'string' ? '$0' : formatTokenAmount(transaction.data.amount, true)}
          </p>
        </div>
      </Flex>
    </div>
  )
}
